<div class="banner-container">
  <mat-card class="banner-card">
    <mat-card-content>
      <div class="banner-content-container">
        <ng-container *ngIf="imageURL">
          <img [src]="imageURL" width="118px" />
        </ng-container>
        <div class="text-container">
          <div class="title">
            {{ title }}
            <glxy-badge *ngIf="badgeText" [color]="badgeColor">
              {{ badgeText }}
            </glxy-badge>
          </div>
          <div class="description">{{ description }}</div>
          <div>
            <button (click)="openLearnMoreModal()" mat-stroked-button>
              {{ 'SMS_REGISTRATION.INFO_BANNER.LEARN_MORE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
